import type { QueryResult } from '@apollo/client';
import { useCallback, useState } from 'react';
import { API } from '@shared/types/api';

type ListWorkflowEntitiesQueryResult = QueryResult<
  API.ListWorkflowEntitiesQuery,
  API.ListWorkflowEntitiesQueryVariables
>;

export function useLoadMore(
  fetchMore: ListWorkflowEntitiesQueryResult['fetchMore'],
  data: ListWorkflowEntitiesQueryResult['data'],
  variables: API.ListWorkflowEntitiesQueryVariables,
) {
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const cursor = data?.list?.cursor;

  const loadMore = useCallback(() => {
    setIsLoadingMore(true);

    fetchMore({
      variables: {
        ...variables,
        input: {
          ...variables.input,
          cursor,
        },
      },
    }).finally(() => setIsLoadingMore(false));
  }, [setIsLoadingMore, fetchMore, variables, cursor]);

  return { isLoadingMore, loadMore };
}
